import React, { ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

import { classNames } from '../../utils/style';

import { ComparisonContext } from './ComparisonContext';

export interface ComparisonTableHeaderTabsProps {
  children: ReactNode;
  className?: string;
}

const TabsHeaderComponent = ({
  children,
  sticky,
  className,
}: ComparisonTableHeaderTabsProps & { sticky?: boolean }) => {
  return (
    <div
      className={classNames(
        'ComparisonTableHeader',
        'bg-white z-10 mb-24',
        sticky && 'fixed top-0 left-0 right-0',
        sticky && 'border-b border-blue-51',
        sticky ? 'isSticky' : 'notSticky',
        className
      )}
    >
      <div
        className={classNames(
          'ComparisonHeaderContainer',
          'flex justify-between items-center'
        )}
      >
        {children}
      </div>
    </div>
  );
};

export const TabsHeader = ({
  children,
  ...props
}: ComparisonTableHeaderTabsProps) => {
  const context = useContext(ComparisonContext);

  return (
    <>
      <TabsHeaderComponent {...props}>{children}</TabsHeaderComponent>
      {context?.sticky &&
        createPortal(
          <TabsHeaderComponent {...props} sticky={context?.sticky}>
            {children}
          </TabsHeaderComponent>,
          document.body
        )}
    </>
  );
};
